export enum VideoType {
	HLS = 'hls',
	CONVENTIONAL = 'conventional',
}

export enum MediaType {
	IMAGE = 'image',
	VIDEO = 'video',
}

export interface Image {
	alt: string;
	height: number;
	src: string;
	width: number;
}

export interface Video {
	hls_url: string;
	original_url: string;
	thumbnail?: string;
}

export interface Media {
	type: MediaType;
	src: string;
	poster?: string;
}
